/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SocialPolicy
 */
export interface SocialPolicy {
    /**
     * Platforms this objective applies to — the platform being followed, or where a post or like is accepted. Common to every social subtype.
     * @type {Array<string>}
     * @memberof SocialPolicy
     */
    acceptedPlatforms: Array<string>;
    /**
     * POST only. A post qualifies if its caption contains ANY of these. Plural so a campaign can accept a primary tag plus a variant.
     * @type {Array<string>}
     * @memberof SocialPolicy
     */
    requiredHashtags?: Array<string>;
    /**
     * LIKE only. The specific posts a brand wants liked. Empty means any URL on an accepted platform counts.
     * @type {Array<string>}
     * @memberof SocialPolicy
     */
    targetPostUrls?: Array<string>;
    /**
     * Credited claims per member per period. Absent is uncapped.
     * @type {number}
     * @memberof SocialPolicy
     */
    maxClaimsPerPeriod?: number;
    /**
     * Campaign-authored copy shown above the claim form, replacing the generated instruction line.
     * @type {string}
     * @memberof SocialPolicy
     */
    instructions?: string;
}

/**
 * Check if a given object implements the SocialPolicy interface.
 */
export function instanceOfSocialPolicy(value: object): value is SocialPolicy {
    if (!('acceptedPlatforms' in value) || value['acceptedPlatforms'] === undefined) return false;
    return true;
}

export function SocialPolicyFromJSON(json: any): SocialPolicy {
    return SocialPolicyFromJSONTyped(json, false);
}

export function SocialPolicyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SocialPolicy {
    if (json == null) {
        return json;
    }
    return {
        
        'acceptedPlatforms': json['acceptedPlatforms'],
        'requiredHashtags': json['requiredHashtags'] == null ? undefined : json['requiredHashtags'],
        'targetPostUrls': json['targetPostUrls'] == null ? undefined : json['targetPostUrls'],
        'maxClaimsPerPeriod': json['maxClaimsPerPeriod'] == null ? undefined : json['maxClaimsPerPeriod'],
        'instructions': json['instructions'] == null ? undefined : json['instructions'],
    };
}

export function SocialPolicyToJSON(json: any): SocialPolicy {
    return SocialPolicyToJSONTyped(json, false);
}

export function SocialPolicyToJSONTyped(value?: SocialPolicy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'acceptedPlatforms': value['acceptedPlatforms'],
        'requiredHashtags': value['requiredHashtags'],
        'targetPostUrls': value['targetPostUrls'],
        'maxClaimsPerPeriod': value['maxClaimsPerPeriod'],
        'instructions': value['instructions'],
    };
}

